import { render, staticRenderFns } from "./sublessorContract.vue?vue&type=template&id=48f9d818&scoped=true"
import script from "./sublessorContract.vue?vue&type=script&lang=js"
export * from "./sublessorContract.vue?vue&type=script&lang=js"
import style0 from "./sublessorContract.vue?vue&type=style&index=0&id=48f9d818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f9d818",
  null
  
)

export default component.exports